import { UMIcon } from '../../urbanmap/_components';
import { distanceKm } from './domain';
import { PC, UMR, caption } from './tokens';
import type { LngLat, WeatherStation } from './types';

interface Props {
  stations: WeatherStation[];
  selected: string;
  center: LngLat | null;
  /** Station la plus proche du périmètre, proposée par défaut. */
  nearestId: string;
  onSelect: (id: string) => void;
}

/** Liste compacte des stations : nom puis degrés-jours standards, deux lignes par station. */
export function StationList({ stations, selected, center, nearestId, onSelect }: Props) {
  const sorted = center
    ? [...stations].sort((a, b) => distanceKm(center, a.position) - distanceKm(center, b.position))
    : stations;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }} role="radiogroup" aria-label="Station météo du projet">
      {sorted.map((s) => {
        const active = s.id === selected;
        return (
          <button
            key={s.id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onSelect(s.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, textAlign: 'left', cursor: 'pointer',
              padding: '4px 6px', background: active ? PC.accentBg : UMR.white,
              border: `1px solid ${active ? PC.accentBorder : 'transparent'}`, font: `400 13px/16px ${UMR.font}`,
              color: UMR.black,
            }}
          >
            <UMIcon name={active ? 'radio_button_checked' : 'radio_button_unchecked'} size={18} color={active ? PC.accent : UMR.textSecondary} />
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {s.name}
                {s.id === nearestId && (
                  <span style={{ fontSize: 11, padding: '0 4px', background: UMR.grey100, border: `1px solid ${UMR.border}`, color: UMR.textSecondary, fontWeight: 400 }}>
                    proche
                  </span>
                )}
              </span>
              <span style={{ ...caption, fontVariantNumeric: 'tabular-nums' }}>DJ standards {s.dju} / {s.djclim}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
